<template>
    <div class="chart-container">
        <div id="chart-container-4" class="chart" style="height: 100%;"></div>
        <div id="chart-container-5" class="chart" style="height: 100%;"></div>
    </div>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";
import * as echarts from 'echarts';

export default {
    name: "oeeQuerySpindle",
    mixins: [EmCommonApi],
    props: {
        autoRefreshFlag: Boolean,   //父组件传递的是否自动刷新标志位
        renderViewFlag: Boolean,     //是否需要渲染组件的标志位
        queryForm: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            chart: {},
            collectTimeList: [],        //x轴时间
            collectTimeFillYesList: [],        //x轴(left echart)时间
            collectTimeFillNoList: [],         //x轴(right echart)时间
            spindleLoadList: [],        //主轴负载
            spindleAloadList: [],        //A轴负载
            spindleC1loadList: [],        //C轴负载
            spindleActSpeedList: [],    //主轴转速
            workInList: [],             //是否上工
            spindleFeedSpeedList: [],   //进给速度
            geometricXList: [],
            geometricYList: [],
            geometricZList: [],
            geometricAList: [],
            geometricC1List: [],
            option: {},
            fresh: {},
            receiveDate: '',
        }
    },
    watch: {
        //监听queryDate的变化，这个queryDate是父组件传递的参数，利用watch监听再刷新当前子组件
        // queryDate(newValue, oldValue) {
        //     console.log("旧日期：" + oldValue + "父组件传递的新日期：" + newValue)
        //     this.getRemoteData();
        // }
        autoRefreshFlag(newVal) {
            if (newVal) {
                // 当 autoRefreshFlag 变为 true 时，执行刷新操作
                this.getRemoteData();
            }
        },
    },
    created() {

    },
    mounted() {
        window.addEventListener('resize', this.chart.resize, false);
    },
    beforeDestroy() {
        clearInterval(this.fresh);
        window.removeEventListener('resize', this.chart.resize, false)
    },
    methods: {
        getRemoteData() {
            if (this.renderViewFlag === false) {
                //清空：渲染空的echart，跳出不执行下面的正常查询和渲染
                this.collectTimeFillYesList = [];       //x轴(left echart)时间
                this.spindleLoadList = [];              //主轴负载
                this.spindleAloadList = [];             //A轴负载
                this.spindleC1loadList = [];            //C轴负载
                this.spindleActSpeedList = [];          //主轴速度
                this.workInList = [];

                this.collectTimeFillNoList = [];        //x轴(right echart)时间
                this.spindleFeedSpeedList = [];         //进给速度
                this.geometricXList = [];
                this.geometricYList = [];
                this.geometricZList = [];
                // 处理完后触发一个自定义事件，通知父组件解锁查询按钮
                this.$emit('data-processed', false);    // 这里可以传递需要的信息
                this.loadChart();
                return;
            }
            const _api = `${this.$_emApiMixin_moduleBaseApi("tpmOeeReportTor")}/tpmOeeReportTor/oeeQueryDeviceSpindleData`
            this.$_emApiMixin_post(_api, this.queryForm, false).then(value => {
                let data = value.data;
                console.log('--------------- 调试：单设备主轴数据查询 后端返回结果 ----------------')
                console.log(data)

                this.collectTimeFillYesList = [];       //x轴(left echart)时间
                this.spindleLoadList = [];              //主轴负载
                this.spindleAloadList = [];             //A轴负载
                this.spindleC1loadList = [];            //C轴负载
                this.spindleActSpeedList = [];          //主轴速度
                this.workInList = [];

                this.collectTimeFillNoList = [];        //x轴(right echart)时间
                this.spindleFeedSpeedList = [];         //进给速度
                this.geometricXList = [];
                this.geometricYList = [];
                this.geometricZList = [];

                //this.collectTimeList = data.collectTime;                //x轴时间
                this.collectTimeFillYesList = data.collectTimeFillYes;                //x轴(left echart)时间
                this.spindleLoadList = data.spindleLoad;            //主轴负载
                this.spindleAloadList = data.spindleAload;      //A轴负载
                this.spindleC1loadList = data.spindleC1load;      //C轴负载
                this.spindleActSpeedList = data.spindleActSpeed;    //主轴速度
                this.workInList = data.workIn;

                this.collectTimeFillNoList = data.collectTimeFillNo;                //x轴(right echart)时间
                this.spindleFeedSpeedList = data.spindleFeedSpeed;  //进给速度
                this.geometricXList = data.geometricX;
                this.geometricYList = data.geometricY;
                this.geometricZList = data.geometricZ;
                // 处理完后触发一个自定义事件，通知父组件解锁查询按钮
                this.$emit('data-processed', false); // 这里可以传递需要的信息

                this.loadChart()
            })
        },
        formatDateTime(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
            const day = String(date.getDate()).padStart(2, '0');

            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        loadChart() {
            // 获取屏幕缩放比例动态计算
            let scale = window.devicePixelRatio || 1;
            // 设定原始字体大小（在100%缩放下的字体大小）
            let originalSize = 20; // 适合100%缩放的字体大小
            // 根据缩放比例调整字体大小（目前调试屏幕缩放比例对应关系：150% - 20 | 125% - 16 | 150% - 13.33~）
            let adjustedSize = originalSize * (1 / scale);
            //console.log("================ adjustedSize ================");
            //console.log(adjustedSize);

            //控制chart和dataZoom的间距
            let spindleChartBottom = "16%";
            if (adjustedSize < 16) {
                //150%缩放要放大间距，否则图形和dataZoom重叠了
                spindleChartBottom = "25%";
            }

            // 创建一个对象来控制系列的legend显示状态
            const selectedSeriesAloadShow = {
                '主轴转速': true,
                '主轴负载': true,
                'A轴负载': true,
                'C轴负载': false,
                '是否上工': true
            };
            const selectedSeriesC1loadShow = {
                '主轴转速': true,
                '主轴负载': true,
                'A轴负载': false,
                'C轴负载': true,
                '是否上工': true
            };
            const selectedSeriesNormalShow = {
                '主轴转速': true,
                '主轴负载': true,
                'A轴负载': false,
                'C轴负载': false,
                '是否上工': true
            };
            const selectedSeriesAllShow = {
                '主轴转速': true,
                '主轴负载': true,
                'A轴负载': true,
                'C轴负载': true,
                '是否上工': true
            };

            this.option1 = {
                // color: ['#9900CC', '#3399FF', '#33CC00'], // 设置全局颜色
                color: ['#3399FF', '#FF9933', '#FF3300', '#FF00FF', '#33CC00'], // 设置全局颜色
                backgroundColor: 'rgba(0, 0, 0, 0.5)', // 设置背景色为半透明的黑色
                title: {
                    text: "主轴数据",
                    textStyle: {
                        color: '#ffffff', // 设置图例文字颜色
                        fontSize: adjustedSize,       // 设置 x 轴刻度标签的字体大小
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['主轴转速(rpm)', '主轴负载(%)', 'A轴负载', 'C轴负载', '是否上工'],
                    textStyle: {
                        color: '#ffffff',       // 设置图例文字颜色
                        fontSize: adjustedSize - 4,           // 设置 x 轴刻度标签的字体大小
                    },
                    //orient: 'vertical', // 设置图例垂直显示
                    //right: 80,          // 可选：调整图例距离图表的右侧距离
                    top: 10,           // 可选：调整图例距离图表的顶部距离
                    itemGap: 20,        // 设置图例项之间的间隔距离，这里设置为20像素
                },
                grid: {             //设置图标位置
                    left: '6%',     // 设置左边距为0%
                    right: '2%',    // 可选，设置右边距
                    bottom: spindleChartBottom,  // 可选，设置底边距
                    top: '13%'      // 可选，设置顶边距
                },
                //color: ['#9900CC', '#3399FF', '#33CC00'], // (全局)设置bar的颜色
                xAxis: {
                    type: 'category',
                    splitLine: {
                        show: true,             // 显示分隔线
                        lineStyle: {
                            color: 'rgba(255, 255, 255, 0.1)'  // 设置分隔线的颜色和透明度
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#ffffff',   // 设置 x 轴刻度标签的字体颜色
                            fontSize: adjustedSize - 2,       // 设置 x 轴刻度标签的字体大小
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ffffff',  // 设置 y 轴轴线颜色
                        }
                    },
                    //data: ['7：59：59', '8:10', '8:20', '8:30', '8:40', '8:50', '9:00'],        //test data【X轴数据】
                    data: this.collectTimeFillYesList,
                    boundaryGap: [0.1, 0.1]
                },
                dataZoom: [
                    {
                        type: 'inside',
                        start: 0,
                        end: 100,
                        textStyle: {
                            color: '#ffffff'
                        }
                    },
                    {
                        textStyle: {
                            color: '#ffffff'
                        },
                        realtime: false,    //是否拖动时实时刷新（如果数据量太大实时刷新会很卡，不如关掉效果好）
                        //backgroundColor: 'rgba(255, 255, 255, 0.4)', // 设置背景色为半透明的黑色
                        //这里设置滚动条样式,和滚动条手柄样式
                        //borderColor: '#8FDFFE',
                        //handleIcon: 'M512 512m-208 0a6.5 6.5 0 1 0 416 0 6.5 6.5 0 1 0-416 0Z M512 192C335.264 192 192 335.264 192 512c0 176.736 143.264 320 320 320s320-143.264 320-320C832 335.264 688.736 192 512 192zM512 800c-159.072 0-288-128.928-288-288 0-159.072 128.928-288 288-288s288 128.928 288 288C800 671.072 671.072 800 512 800z',
                        //handleColor: '#8FDFFE',
                        //handleSize: 15,
                    }
                ],
                yAxis: [
                    {
                        //【给主轴数据用的y轴坐标系 yAxisIndex: 0】
                        type: 'value',
                        splitLine: {
                            show: true,             // 显示分隔线
                            lineStyle: {
                                color: 'rgba(255, 255, 255, 0.1)'  // 设置分隔线的颜色和透明度
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#ffffff',   // 设置 x 轴刻度标签的字体颜色
                                fontSize: adjustedSize - 3,
                            },
                            //formatter: '{value}%',    // 自定义标签格式
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#ffffff'  // 设置 y 轴轴线颜色
                            }
                        },
                        //data: [], //test data
                        inverse: false, // 将 y 轴刻度颠倒显示
                        //data: this.dataValueX
                    },
                    {
                        //【给工时记录用的y轴坐标系 yAxisIndex: 1】
                        //【注意】2024.4.11 客户要求右侧y轴不显示，因为坐标数据和左侧y轴数据对应不上，看起来很奇怪
                        type: 'value',
                        splitLine: {
                            show: false,             // 显示分隔线
                            lineStyle: {
                                color: 'rgba(255, 255, 255, 0.1)'  // 设置分隔线的颜色和透明度
                            }
                        },
                        axisLabel: {
                            show: false, // 不显示刻度标签
                            textStyle: {
                                color: '#ffffff',   // 设置 x 轴刻度标签的字体颜色
                                fontSize: adjustedSize - 3,
                            },
                            //formatter: '{value}%',    // 自定义标签格式
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: '#ffffff'  // 设置 y 轴轴线颜色
                            }
                        },
                        //data: [], //test data
                        inverse: false, // 将 y 轴刻度颠倒显示
                        //data: this.dataValueX
                    },
                ],
                series: [
                    {
                        name: '主轴转速(rpm)',
                        type: 'line',
                        // 设置线条样式
                        lineStyle: {
                            width: 2,        // 设置线条宽度为2像素
                            //color: '#9900CC'
                        },
                        yAxisIndex: 0,    // 使用左侧的 y 轴
                        smooth: true,   //平滑线条
                        symbol: 'none', // 隐藏标记点
                        //data: [22, 0, 19, 23, 29, 33, 31]
                        data: this.spindleActSpeedList.map(value => Math.round(value)),  //主轴转速保留整数
                    },
                    {
                        name: '主轴负载(%)',
                        type: 'line',
                        lineStyle: {
                            width: 2,        // 设置线条宽度为2像素
                            //color: '#3399FF'
                        },
                        yAxisIndex: 0,    // 使用左侧的 y 轴
                        smooth: true,   //平滑线条
                        symbol: 'none', // 隐藏标记点
                        //data: [0, 0.65, 1.54, 2.89, 7.91, 3.22, 0.11]
                        data: this.spindleLoadList,
                    },
                    {
                        name: 'A轴负载',
                        type: 'line',
                        lineStyle: {
                            width: 2,        // 设置线条宽度为2像素
                            //color: '#AADD00'
                        },
                        yAxisIndex: 0,    // 使用左侧的 y 轴
                        smooth: true,   //平滑线条
                        symbol: 'none', // 隐藏标记点
                        data: this.spindleAloadList,
                    },
                    {
                        name: 'C轴负载',
                        type: 'line',
                        lineStyle: {
                            width: 2,        // 设置线条宽度为2像素
                            //color: '#AADD00'
                        },
                        yAxisIndex: 0,    // 使用左侧的 y 轴
                        smooth: true,   //平滑线条
                        symbol: 'none', // 隐藏标记点
                        data: this.spindleC1loadList,
                    },
                    {
                        name: '是否上工',
                        //data: [1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 1, 0],
                        data: this.workInList,  // 0 或 1 控制是否显示
                        type: 'bar',
                        barWidth: '100%', // 控制柱状图的宽度
                        yAxisIndex: 1,    // 将 bar 放在右侧的 y 轴上
                        itemStyle: {
                            color: function (params) {
                                // 根据数据值设置柱状图颜色
                                return params.data === 1 ? 'rgba(81, 200, 0, 0.2)' : 'rgba(255, 0, 0, 0.6)';
                            },
                        },
                    },
                ]
            }
            this.option2 = {
                color: ['#FF00FF', '#3399FF', '#33CC00', '#FF4400'], // 设置全局颜色
                backgroundColor: 'rgba(0, 0, 0, 0.5)', // 设置背景色为半透明的黑色
                title: {
                    text: "主轴数据",
                    textStyle: {
                        color: '#ffffff', // 设置图例文字颜色
                        fontSize: adjustedSize,       // 设置 x 轴刻度标签的字体大小
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['进给速度(mm/min)', 'x轴坐标(mm)', 'y轴坐标(mm)', 'z轴坐标(mm)'],
                    textStyle: {
                        color: '#ffffff',       // 设置图例文字颜色
                        fontSize: adjustedSize - 4,           // 设置 x 轴刻度标签的字体大小
                    },
                    //orient: 'vertical', // 设置图例垂直显示
                    //right: 80,          // 可选：调整图例距离图表的右侧距离
                    top: 10,           // 可选：调整图例距离图表的顶部距离
                    itemGap: 20,        // 设置图例项之间的间隔距离，这里设置为20像素
                },
                grid: {             //设置图标位置
                    left: '8%',     // 设置左边距为0%
                    right: '2%',    // 可选，设置右边距
                    bottom: spindleChartBottom,  // 可选，设置底边距
                    top: '15%'      // 可选，设置顶边距
                },
                //color: ['#9900CC', '#3399FF', '#33CC00'], // (全局)设置bar的颜色
                xAxis: {
                    type: 'category',
                    splitLine: {
                        show: true,             // 显示分隔线
                        lineStyle: {
                            color: 'rgba(255, 255, 255, 0.1)'  // 设置分隔线的颜色和透明度
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#ffffff',   // 设置 x 轴刻度标签的字体颜色
                            fontSize: adjustedSize - 2,       // 设置 x 轴刻度标签的字体大小
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ffffff'  // 设置 y 轴轴线颜色
                        }
                    },
                    //data: ['8:00', '8:10', '8:20', '8:30', '8:40', '8:50', '9:00'],        //<--------【X轴数据】
                    data: this.collectTimeFillNoList,
                    boundaryGap: [0, 0.01]
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: true,             // 显示分隔线
                        lineStyle: {
                            color: 'rgba(255, 255, 255, 0.1)'  // 设置分隔线的颜色和透明度
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#ffffff',   // 设置 x 轴刻度标签的字体颜色
                            fontSize: adjustedSize - 3,       // 设置 x 轴刻度标签的字体大小
                        },
                        //formatter: '{value}%',    // 自定义标签格式
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ffffff'  // 设置 y 轴轴线颜色
                        }
                    },
                    //data: [], //test data
                    inverse: false, // 将 y 轴刻度颠倒显示
                    //data: this.dataValueX
                },
                dataZoom: [
                    {
                        type: 'inside',
                        start: 0,
                        end: 100,
                        textStyle: {
                            color: '#ffffff'
                        }
                    },
                    {
                        textStyle: {
                            color: '#ffffff'
                        },
                        realtime: false,    //是否拖动时实时刷新（如果数据量太大实时刷新会很卡，不如关掉效果好）
                        //backgroundColor: 'rgba(255, 255, 255, 0.4)', // 设置背景色为半透明的黑色
                        //这里设置滚动条样式,和滚动条手柄样式
                        //borderColor: '#8FDFFE',
                        //handleIcon: 'M512 512m-208 0a6.5 6.5 0 1 0 416 0 6.5 6.5 0 1 0-416 0Z M512 192C335.264 192 192 335.264 192 512c0 176.736 143.264 320 320 320s320-143.264 320-320C832 335.264 688.736 192 512 192zM512 800c-159.072 0-288-128.928-288-288 0-159.072 128.928-288 288-288s288 128.928 288 288C800 671.072 671.072 800 512 800z',
                        //handleColor: '#8FDFFE',
                        //handleSize: 15,
                    }
                ],
                series: [
                    {
                        name: '进给速度(mm/min)',
                        type: 'line',
                        //stack: 'stack1', // 使用相同的 stack 值
                        //yAxisIndex: 0, // 设置使用第一个纵轴
                        // 设置线条样式
                        lineStyle: {
                            width: 2,            // 设置线条宽度为2像素
                            //color: '#FFCC00'
                        },
                        smooth: true,   //平滑线条
                        symbol: 'none', // 隐藏标记点
                        //data: [22, 18, 19, 23, 29, 33, 31]
                        data: this.spindleFeedSpeedList.map(value => Math.round(value)),  //进给速度保留整数,
                    },
                    {
                        name: 'x轴坐标(mm)',
                        type: 'line',
                        lineStyle: {
                            width: 2,            // 设置线条宽度为2像素
                            //color: '#ff0000'
                        },
                        smooth: true,   //平滑线条
                        symbol: 'none', // 隐藏标记点
                        //data: [0, 0.65, 1.54, 2.89, 7.91, 3.22, 0.11]
                        data: this.geometricXList,
                    },
                    {
                        name: 'y轴坐标(mm)',
                        type: 'line',
                        lineStyle: {
                            width: 2 // 设置线条宽度为2像素
                        },
                        smooth: true,   //平滑线条
                        symbol: 'none', // 隐藏标记点
                        //data: [0, 0, 0, 1, 0, 0, 0]
                        data: this.geometricYList,
                    },
                    {
                        name: 'z轴坐标(mm)',
                        type: 'line',
                        lineStyle: {
                            width: 2 // 设置线条宽度为2像素
                        },
                        smooth: true,   //平滑线条
                        symbol: 'none', // 隐藏标记点
                        //data: [0, 0, 0, 1, 0, 0, 0]
                        data: this.geometricZList,
                    }
                ]
            }

            //2023.11.5 S1-20、S3-28特殊处理，S1-20显示C轴负载曲线，S3-28显示A轴负载曲线
            if (this.queryForm.machineCode === 'S3-28') {
                this.option1.legend.selected = selectedSeriesAllShow;
            } else if (this.queryForm.machineCode === 'S1-20') {
                this.option1.legend.selected = selectedSeriesC1loadShow;
            } else {
                this.option1.legend.selected = selectedSeriesNormalShow;
            }

            this.chart = echarts.init(document.getElementById("chart-container-4"));
            this.chart.setOption(this.option1)

            this.chart = echarts.init(document.getElementById("chart-container-5"));
            this.chart.setOption(this.option2)
            //echart浏览器自动缩放
            // let myChart = this.chart;
            // window.addEventListener('resize', () => {
            //     myChart.resize();
            // })
        }
    }
}
</script>

<style scoped>
#chart-container-4 {
    border: 2px dashed #ffffff; /* 设置虚线边框样式 */
    padding: 10px; /* 可选：添加内边距，使虚线边框更明显 */
    box-sizing: border-box; /* 可选：确保内边距不会增加容器的实际宽度 */
}

#chart-container-5 {
    border: 2px dashed #ffffff; /* 设置虚线边框样式 */
    padding: 10px; /* 可选：添加内边距，使虚线边框更明显 */
    box-sizing: border-box; /* 可选：确保内边距不会增加容器的实际宽度 */
}

.chart-container {
    display: flex;
    height: 100%;
}

.chart {
    flex: 1;
    margin: 15px;
}
</style>
